import { withTableView } from '@components/enitity/table/Table.view'
import { LandlordsTable } from '@features/landlords/components/LandlordsTable'
import { useTranslation } from 'react-i18next'

export const Landlords = () => {
  const { t } = useTranslation('users')

  const TableWithView = withTableView(LandlordsTable, t('landlords'))

  return <TableWithView />
}
